import { render, staticRenderFns } from "./client-imageupload.vue?vue&type=template&id=23ecba84&scoped=true"
import script from "./client-imageupload.vue?vue&type=script&lang=js"
export * from "./client-imageupload.vue?vue&type=script&lang=js"
import style0 from "./client-imageupload.vue?vue&type=style&index=0&id=23ecba84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecba84",
  null
  
)

export default component.exports